import { Colors } from "@auteco/theme";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
    dialogContent: {
        minWidth: '400px',
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: '20px'
    },
    dialogTitle: {
        padding: '0 24px 12px '
    },
    materialTitle: {
        marginBottom: '12px'
    },
    textField: {
        marginTop: '20px'
    },
    amount: {
        width: '120px',
        marginLeft: '12px'
    },
    amountGreen: {
        width: '130px',
        '& .MuiInputBase-root  ': {
            color: 'green'
        }
    },
    amountRed: {
        width: '160px',
        '& .MuiInputBase-root  ': {
            color: 'red'
        }
    },
    inputLabel: {
        margin: '20px 0 5px 10px'
    },
    typeSelected: {
        fontWeight: 'bold',
        color: Colors.DARK_BLUE
    },
    switch: {
        '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
            background: Colors.DARK_BLUE
        },
        '& .MuiSwitch-track': {
            background: Colors.BLUE
        },
        '& .MuiSwitch-thumb': {
            color: Colors.BLUE
        },
        '& .Mui-checked': {
            color: Colors.DARK_BLUE
        },
    },
    actionBtn: {
        width: '200px',
        margin: '12px auto 12px',
        background: Colors.DARK_BLUE,
        color: 'white',
        '&:hover': {
            background: Colors.DARK_BLUE
        }
    },
    eventSubtitle: {
        fontWeight: 'bold'
    },
    monthsMainContainer: {
        maxHeight: '200px',
        paddingRight: '8px',
        overflowY: 'scroll',
    },
    monthContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'end',
        margin: '8px 0'
    },
    dateMonth: {
        width: '200px'
    },
    addBtn: {
        width: '32px',
        height: '32px',
        marginTop: '12px',
        background: Colors.DARK_GRAY_BACKGROUND,
        border: `1px solid ${Colors.DARK_BLUE}`,
        color: Colors.DARK_BLUE
    }
}))

export { useStyles }